import axios from 'axios'
import getSearchConfig from './functions/get-search-config'

const MODULE_BASE_URL = process.env.MODULE_SEARCH_API_BASE
const EVENT_BASE_URL = process.env.EVENT_SEARCH_API_BASE

function getModuleFilters () {
  return axios.get(`${MODULE_BASE_URL}filters/`)
}

function getModules (params) {
  return axios.get(`${MODULE_BASE_URL}modules/`, { params })
}

function getEventFilters () {
  return axios.get(`${EVENT_BASE_URL}filters/`)
}

function getEvents (params) {
  return axios.get(`${EVENT_BASE_URL}events/`, { params })
}

export default {
  getFilters () {
    const source = getSearchConfig().source

    if (source === 'modules') {
      return getModuleFilters()
    } else if (source === 'events') {
      return getEventFilters()
    }
  },

  getResults (params) {
    const source = getSearchConfig().source

    if (source === 'modules') {
      return getModules(params)
    } else if (source === 'events') {
      return getEvents(params)
    }
  }
}
